import React from 'react';
import PropTypes from 'prop-types';
import TreatmentsReport from '../TreatmentsReport';

/**
 * Componente funcional ManagerDashboard
 * Exibe um título, subtítulo e conteúdo children.
 */
const ManagerDashboard = ({ 
    title = 'Dashboard Gerencial', 
    subtitle, 
    interval={datei: new Date().toLocaleDateString('en-ca'), datef: new Date().toLocaleDateString('en-ca')} 
}) => {

	return (
		<section className="p-5 font-sans">
			<header className="mb-3">
				<h1 className="m-0 text-2xl">{title}</h1>
				{subtitle && <p className="m-0 text-gray-500">{subtitle}</p>}
			</header>
			<main className="bg-gray-50 p-4 rounded">
                <TreatmentsReport interval={interval} />
            </main>
		</section>
	);
};

ManagerDashboard.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
	children: PropTypes.node,
};

export default ManagerDashboard;
